var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vendor-coverage-container" }, [
    _vm.loading
      ? _c("div", [_vm._v("Loading Please wait...")])
      : _c(
          "div",
          [
            _c(
              "sticky",
              {
                attrs: {
                  "z-index": 10,
                  "class-name": "sub-navbar",
                  title:
                    "Vendor " +
                    _vm.coverageForm.vendorId +
                    " - " +
                    _vm.coverageForm.firstName +
                    " " +
                    _vm.coverageForm.lastName,
                },
              },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    attrs: { type: "warning" },
                    on: { click: _vm.cancelClick },
                  },
                  [_vm._v(" Cancel ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-cards" },
              [
                _c("VendorCoverage", {
                  staticClass: "ca-card full-width",
                  attrs: { isEdit: _vm.isEdit },
                  model: {
                    value: _vm.coverageForm,
                    callback: function ($$v) {
                      _vm.coverageForm = $$v
                    },
                    expression: "coverageForm",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }